import { useTranslation } from 'react-i18next'

import { EMPTY_OBJECT } from '../../../../constants/common'
import { Divider } from '../../../Divider'
import { Content } from '../../../Modal'
import Text from '../../../Text'
import { buildEpostStatusTimeline } from '../EpostStatusTimeline.utils'
import { EpostStatusTimelineRecipient } from '../EpostStatusTimelineRecipient'
import { EpostStatusTimelineTracking } from '../EpostStatusTimelineTracking'
import { EpostStatusTimelineTrackingId } from '../EpostStatusTimelineTrackingId'

import * as styles from './EpostStatusTimelineContent.module.css'

function EpostStatusTimelineModalContent({ timeline, user }) {
  const { t } = useTranslation()

  const { regmail_tracking_id: regmailTrackingId, ...restTimeline } =
    timeline?.[0] || EMPTY_OBJECT

  return (
    <Content contentWrapperClassName={styles.contentWrapper}>
      <Text isSecondary>{t('EpostStatusTimeline.InfoTextKey')}</Text>

      <Divider className={styles.divider} />

      <EpostStatusTimelineTracking
        timeline={buildEpostStatusTimeline(restTimeline)}
      />

      <EpostStatusTimelineTrackingId trackingId={regmailTrackingId} />

      <EpostStatusTimelineRecipient user={user} />
    </Content>
  )
}

export default EpostStatusTimelineModalContent
